import { render, staticRenderFns } from "./StaticPageTiles.vue?vue&type=template&id=039f34f0&scoped=true&"
import script from "./StaticPageTiles.vue?vue&type=script&lang=js&"
export * from "./StaticPageTiles.vue?vue&type=script&lang=js&"
import style0 from "./StaticPageTiles.vue?vue&type=style&index=0&id=039f34f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039f34f0",
  null
  
)

export default component.exports